
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD3rVJKNNl0Vdwglqzq5TNWDQ5MlaCT22Q",
  authDomain: "studio-413020376-3c794.firebaseapp.com",
  projectId: "studio-413020376-3c794",
  storageBucket: "studio-413020376-3c794.appspot.com",
  messagingSenderId: "657251383485",
  appId: "1:657251383485:web:56fe76b746a428ebec9fd4"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
